module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm2_m.91e69e4564e431d258d0907440173bc3.png";